<div class={classes}>
  {#if Template}
    <svelte:component this={Template} />
  {:else}
    <p>Template "{$store.render.template.custom.ref}" not found.</p>
  {/if}
</div>

<script>
  import { getContext } from 'svelte'

  const platform = getContext('platform')
  const { store } = platform

  // We use the store render, this is here to prevent warnings
  export const render = null
  export let cmsClasses = ''

  let component = platform.components[$store.render.template.custom.ref]
  let Template = component?.default
  let classes = ''

  platform.router.after(() => {
    component = platform.components[$store.render.template.custom.ref]
    Template = component?.default
  })

  $: if (Array.isArray(component?.layouts)) {
    $store.layouts = component.layouts
  } else {
    $store.layouts = []
  }

  $: {
    classes = [
      cmsClasses,
      Array.isArray(component?.classNames) ? component.classNames.join(' ') : '',
      'cms-template',
    ].filter(c => !!c).join(' ') || ''
  }
</script>

<style lang="scss">:global(html),
:global(body) {
  margin: 0;
  padding: 0;
  font: 13px sans-serif;
  line-height: normal;
  background: #fff;
  color: #333;
  min-height: 100vh;
}
:global(html) {
  box-sizing: border-box;
  overflow-x: hidden;
}
:global(*),
:global(*:before),
:global(*:after) {
  box-sizing: inherit;
}
:global(a) {
  color: #039be5;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
}
:global(img) {
  border: none;
  max-width: 100%;
  height: auto;
}
:global([data-lazy-src][data-lazy-show]),
:global([data-lazy-src].cms-lazy-show) {
  opacity: 1;
}
:global(hr) {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}
:global(audio),
:global(canvas),
:global(iframe),
:global(img),
:global(svg),
:global(video) {
  vertical-align: middle;
}
:global(.cms-plugin) {
  position: relative;
  display: block;
}
:global([data-lazy-background-src]) {
  background-image: url("/static/images/placeholder.gif");
  transition: background-image 0.3s;
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>